/**
 * User Roles and Permissions Configuration
 */

export const ROLES = {
  VIEWER: 'viewer',
  OPERATOR: 'operator',
  MANAGER: 'manager',
  ADMIN: 'admin',
  SUPER_ADMIN: 'super-admin',
};

/**
 * Role hierarchy (higher number = more permissions)
 */
export const ROLE_HIERARCHY = {
  [ROLES.VIEWER]: 1,
  [ROLES.OPERATOR]: 2,
  [ROLES.MANAGER]: 3,
  [ROLES.ADMIN]: 4,
  [ROLES.SUPER_ADMIN]: 5,
};

/**
 * Permissions matrix
 */
export const PERMISSIONS = {
  // Dashboard
  VIEW_DASHBOARD: 'view:dashboard',
  
  // Devices
  VIEW_DEVICES: 'view:devices',
  QUERY_DEVICES: 'query:devices',
  MANAGE_DEVICES: 'manage:devices',
  
  // Map
  VIEW_MAP: 'view:map',
  
  // Analytics
  VIEW_ANALYTICS: 'view:analytics',
  EXPORT_DATA: 'export:data',
  
  // Queries
  EXECUTE_QUERIES: 'execute:queries',
  VIEW_QUERY_HISTORY: 'view:query-history',
  FULL_QUERY_ACCESS: 'full:query-access', // Full access to all query types and data
  LIMITED_QUERY_ACCESS: 'limited:query-access', // Limited access with filtered responses
  
  // Users
  VIEW_USERS: 'view:users',
  MANAGE_USERS: 'manage:users',
  
  // Settings
  VIEW_SETTINGS: 'view:settings',
  MANAGE_SETTINGS: 'manage:settings',
};

/**
 * Role to permissions mapping
 */
export const ROLE_PERMISSIONS = {
  [ROLES.VIEWER]: [
    PERMISSIONS.VIEW_DASHBOARD,
    PERMISSIONS.VIEW_MAP,
    PERMISSIONS.EXECUTE_QUERIES,
    PERMISSIONS.LIMITED_QUERY_ACCESS,
  ],
  [ROLES.OPERATOR]: [
    PERMISSIONS.VIEW_DASHBOARD,
    PERMISSIONS.VIEW_DEVICES,
    PERMISSIONS.QUERY_DEVICES,
    PERMISSIONS.VIEW_MAP,
    PERMISSIONS.EXECUTE_QUERIES,
    PERMISSIONS.VIEW_QUERY_HISTORY,
    PERMISSIONS.LIMITED_QUERY_ACCESS,
  ],
  [ROLES.MANAGER]: [
    PERMISSIONS.VIEW_DASHBOARD,
    PERMISSIONS.VIEW_DEVICES,
    PERMISSIONS.QUERY_DEVICES,
    PERMISSIONS.VIEW_MAP,
    PERMISSIONS.VIEW_ANALYTICS,
    PERMISSIONS.EXPORT_DATA,
    PERMISSIONS.EXECUTE_QUERIES,
    PERMISSIONS.VIEW_QUERY_HISTORY,
    PERMISSIONS.FULL_QUERY_ACCESS,
  ],
  [ROLES.ADMIN]: [
    PERMISSIONS.VIEW_DASHBOARD,
    PERMISSIONS.VIEW_DEVICES,
    PERMISSIONS.QUERY_DEVICES,
    PERMISSIONS.MANAGE_DEVICES,
    PERMISSIONS.VIEW_MAP,
    PERMISSIONS.VIEW_ANALYTICS,
    PERMISSIONS.EXPORT_DATA,
    PERMISSIONS.EXECUTE_QUERIES,
    PERMISSIONS.VIEW_QUERY_HISTORY,
    PERMISSIONS.FULL_QUERY_ACCESS,
    PERMISSIONS.VIEW_USERS,
    PERMISSIONS.MANAGE_USERS,
    PERMISSIONS.VIEW_SETTINGS,
    PERMISSIONS.MANAGE_SETTINGS,
  ],
  [ROLES.SUPER_ADMIN]: [
    // All permissions
    ...Object.values(PERMISSIONS),
  ],
};

/**
 * Check if a role has a specific permission
 */
export const hasPermission = (role, permission) => {
  const rolePermissions = ROLE_PERMISSIONS[role] || [];
  return rolePermissions.includes(permission);
};

/**
 * Check if a role has at least the minimum required role level
 */
export const hasMinimumRole = (userRole, requiredRole) => {
  const userLevel = ROLE_HIERARCHY[userRole] || 0;
  const requiredLevel = ROLE_HIERARCHY[requiredRole] || 0;
  return userLevel >= requiredLevel;
};






